import { AdInterface } from '../../../../store/contexts/types/ad';

export function optionalsFactory(
  category: string,
  foundOptionals: AdInterface['veiculo']['opcionais'] | undefined
): AdInterface['veiculo']['opcionais'] {
  const optionalItems = foundOptionals
    ?.filter(optional => optional.categoria.toLowerCase() === category.toLowerCase())
    .sort((a, b) => (a.id > b.id ? 1 : -1)) as AdInterface['veiculo']['opcionais'];

  return optionalItems;
}

export function getOptionsIds(
  category: string,
  opcionais: AdInterface['veiculo']['opcionais'] | undefined
): number[] {
  if (!opcionais) {
    return [];
  }
  return opcionais
    ?.filter(optional => optional.categoria.toLowerCase() === category.toLowerCase())
    .map(optional => optional.id);
}
